import { SortOptionEnum } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

export interface ISortOptions {
  label: string;
  shortLabel: string;
  // value - Does not need i18n, used in the radio group only
  value: SortOptionEnum;
}

export const useSort = () => {
  const { t } = useI18nContext();

  const sortOptions: ISortOptions[] = [
    {
      label: t("sortOption.recommended"),
      shortLabel: t("sortOption.recommended"),
      value: SortOptionEnum.FareScore,
    },
    {
      label: t("sortOption.price"),
      shortLabel: t("sortOption.priceShortened"),
      value: SortOptionEnum.Price,
    },
    {
      label: t("sortOption.depart"),
      shortLabel: t("depart"),
      value: SortOptionEnum.DepartureTime,
    },
    {
      label: t("sortOption.arrive"),
      shortLabel: t("sortOption.arriveShortened"),
      value: SortOptionEnum.ArrivalTime,
    },
    {
      label: t("sortOption.stops"),
      shortLabel: t("sortOption.stopsShortened"),
      value: SortOptionEnum.Stops,
    },
    {
      label: t("sortOption.duration"),
      shortLabel: t("sortOption.durationShortened"),
      value: SortOptionEnum.Duration,
    },
  ];

  const getSortLabelKey = (sortOption: SortOptionEnum): string =>
    sortOptions.find((option) => option.value === sortOption)?.shortLabel || "";

  return {
    context: { sortOptions },
    handlers: { getSortLabelKey },
  };
};
